export default __webpack_public_path__ + "static/media/help8.8dd83e42.png";